import { Box, CircularProgress } from '@mui/material';

export const Loadin = () => {
    return(
        <Box width={'100%'} height={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <CircularProgress size={'8rem'} color='secondary'/>
        </Box>
    );
};